/**
 * Created by StoneWang on 2020/11/27.
 */
import React from 'react';
import Reflux from 'reflux';
import {
  Row,
  Modal,
  Button,
  message,
} from 'antd';
import {
  hashHistory,
  Link,
  withRouter,
} from 'react-router';
import { DmsTab, TableView, AdvanceFormNew } from 'Components';
import {
  advertList,
  updateStatus,
} from '../../service/carousel';
import { customerList } from '../../service/shoppingCar';
import {
  showSpin,
  hideSpin,
} from 'Utils';
import { Store, Actions } from './store';
import {typeMap} from './constant';
const confirm = Modal.confirm;
class InfoList extends Reflux.Component {
  constructor (props) {
    super(props);
    const currentChannel = window.sessionStorage.getItem('cur_channel') || '';
    this.channelCode = currentChannel.split('|')[1] || '';
    this.store = Reflux.initStore(Store); //创建一个Store实例
    this.state = {
      filterBoxVisible: false,
      customerList: [],
      selectedRowKeys: [],
      rows: [],
      total: 0,
      searchObj: {
        timeStart: '',
        timeEnd: '',
        // customerId: '',
        s: 10,
        p: 1,
      }
    };
    this.getData = this.getData.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.visibleChange = this.visibleChange.bind(this);
    this.setFilterParam = this.setFilterParam.bind(this);
    this.advanceReset = this.advanceReset.bind(this);
    this.advanceSubmit = this.advanceSubmit.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
    this.invalidHandle = this.invalidHandle.bind(this);
    this.validHandle = this.validHandle.bind(this);
    this.deleteHandle = this.deleteHandle.bind(this);
  }
  routeLeaveHook(nextLocation) {
    let path = nextLocation.pathname
    if(/^\/carousel\/add\/\d+$/.test(path)){ //当下一个路由是详情页时，将useStore的值设为true
      Actions.useStoreChange(true);
      Actions.paramChange({...this.state.searchObj});
    }else{
      Actions.useStoreChange(false);
    }
  }
  componentWillMount () { //准备数据
    const self = this;
    const data = this.store.state;
    if (data.useStore) { //根据useStore的值判断是否使用store中的数据
      this.setState({
        ...this.state,
        searchObj: {
          ...this.state.searchObj,
          ...data.params,
        }
      });
    }

    /*customerList(self.channelCode).then(res => { //人员
      if (res.status && res.code == 200) {
        const list = (res.data || []).map(x => ({value:`${x.id}`, text: x.name}));
        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({
              customerList: list,
              searchObj: {
                ...self.state.searchObj,
                customerId: list[0] ? list[0].value : ''
              },
            });
          }
        }, 200);
      } else {
        message.error(res.message);
      }
    });*/
  }

  componentDidMount() {
    this.mounted = true;
    this.getData();
    //设置离开当前路由时的钩子函数
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }
  getData(){
    const self = this;
    const {searchObj} = this.state;
    advertList(searchObj).then(res => {
      if(res.status){
        self.setState({total: res.total, rows: res.data});
      }else{
        console.error(res.message);
      }
    });
  }

  goView (url) {
    hashHistory.push(url);
  }

  visibleChange () {
    this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
  }

  advanceReset () {
    const self=this;
    this.setState({
        filterBoxVisible: false,
        searchObj: {
          ...this.state.searchObj,
          timeStart: '',
          timeEnd: '',
          // customerId: '',
          //s: 10,
          p: 1,
        }},
      function(){
        self.getData();
      })
  };

  advanceSubmit (form) {
    const self = this;
    this.setState({ filterBoxVisible: false, searchObj: { ...this.state.searchObj, p: 1 } }, function(){
      self.getData();
    });
  };

  setFilterParam (name, value) {
    // console.log(name + ':\t' + value);
    if (name === 'time') {
      this.setState({
        searchObj: {
          ...this.state.searchObj,
          timeStart: value.from,
          timeEnd: value.end
        }
      })
    } else {
      this.setState({ searchObj: { ...this.state.searchObj, [name]: value } })
    }
  };

  pageChange (page, pageSize) {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s:pageSize, p: page } }, function(){
      self.getData();
    });
  }
  deleteHandle () {
    const self = this;
    const { selectedRowKeys } = this.state;
    if(!selectedRowKeys.length) {
      message.warn('请选择要删除的广告');
      return;
    }
    confirm({
      title: '确定要删除这些广告?',
      // content: 'When clicked the OK button, this dialog will be closed after 1 second',
      onOk() {
        showSpin();
        updateStatus({ids: selectedRowKeys, status: 2}).then(res => {
          hideSpin();
          self.setState({ selectedRowKeys: []})
          message[res.status ? 'success' : 'error'](res.message);
          res.status && self.getData();
        });
      },
      onCancel() {},
    });
  }
  // invalidHandle validHandle deleteHandle
  invalidHandle () {
    const { selectedRowKeys } = this.state;
    if(!selectedRowKeys.length) {
      message.warn('请选择要禁用的广告');
      return;
    }
    showSpin();
    updateStatus({ids: selectedRowKeys, status: 0}).then(res => {
      hideSpin();
      this.setState({ selectedRowKeys: []})
      message[res.status ? 'success' : 'error'](res.message);
      res.status && this.getData();
    });
  }
  validHandle () {
    const { selectedRowKeys } = this.state;
    if(!selectedRowKeys.length) {
      message.warn('请选择要启用的广告');
      return;
    }
    showSpin();
    updateStatus({ids: selectedRowKeys, status: 1}).then(res => {
      hideSpin();
      this.setState({ selectedRowKeys: []})
      message[res.status ? 'success' : 'error'](res.message);
      res.status && this.getData();
    });
  }
  render () {
    const { rows, total, searchObj, customerList, selectedRowKeys } = this.state;
    const advanceProps = {
      fileds: [
        // {
        //   name: 'customerId',
        //   label: '客户名称',
        //   text: '选择客户',
        //   options: customerList,
        //   multiple: false,
        //   type: 'select',
        //   defaultValue: searchObj.customerId
        // },
        {
          name: 'time',//startCreatedDate, endCreatedDate
          label: '发布时间',
          options: [
            {text: '开始时间'},
            {text: '结束时间'},
          ],
          type: 'dateComp',
          defaultValue: {
            from: searchObj.startDate || '',
            end: searchObj.endDate || ''
          }
        },
      ],
      handle: this.advanceSubmit,
      reset: this.advanceReset,
      fieldHandle: this.setFilterParam
    };
    const tableViewProps = {
      loading: false,
      rowKey: 'id',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      rowSelection: {
        selectedRowKeys: selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) =>  this.setState({selectedRowKeys})
      },
      // 客户名称
      // 广告图描述
      // 类型
      // 广告图数量
      // 发布人
      // 发布时间
      // 状态
      columns: [
        {
          title: '客户名称',
          dataIndex: 'customerName',
          // render: (text, record, index) => {
          //   return <a href={`#/customer/${record.customerId}`}>{text}</a>
          // }
        },
        {
          title: '广告描述',
          dataIndex: 'content'
        }, {
          title: '类型',
          dataIndex: 'type',
          //typeMap
          render: (text, record, index) => {
            let keys = text ? text.split(',') : [];
            return keys.map(x => typeMap[x] || '').filter(x => !!x).join();
          }
        }, {
          title: '广告图数量',
          dataIndex: 'picCount'
        }, {
          title: '发布人',
          dataIndex: 'userName'
        }, {
          title: '发布时间',
          dataIndex: 'publishDateText',
          render: (text) => text ? new Date(text).format('yyyy-MM-dd hh:mm') : ''
        },{
          title: '状态',
          dataIndex: 'isEnable',
          render: (text, record, index) => <span style={{color: text === 1 ? '#00924c' : 'red'}}>{record.isEnableText}</span>
        },
        {
          title: '操作',
          dataIndex: 'id',
          render: (text, record, index) => <Link to={`/carousel/add/${text}`}>编辑</Link>,
        },
      ],
      rows
    };
    return <div className="dms-body">
      <DmsTab options={['广告发布管理']} defaultKey={0}>
        {/*<Button icon="plus" onClick={this.goView.bind(this, `/carousel/add/0`)}>新增</Button>*/}
      </DmsTab>

      <div className="advanceForm-box">
        <div className="advanceForm-content">
          <AdvanceFormNew {...advanceProps} />
        </div>
      </div>
      <div className="dms-table-box">
        <Row className="mb-12" type="flex" justify="end" align="middle" >
          <Button onClick={this.goView.bind(this, `/carousel/add/0`)}>新建</Button>
          &emsp;
          <Button onClick={this.deleteHandle.bind(this)}>删除</Button>
          &emsp;
          <Button onClick={this.invalidHandle.bind(this)}>一键禁用</Button>
          &emsp;
          <Button onClick={this.validHandle.bind(this)}>一键启用</Button>
        </Row>
        <TableView {...tableViewProps}/>
      </div>
    </div>
  }
}
export default withRouter(InfoList);



// WEBPACK FOOTER //
// ./src/routes/carousel/list.js